import React, { useEffect, useCallback } from 'react'
import { Typography, IconButton } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import useEmblaCarousel from 'embla-carousel-react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const useStyles = makeStyles(theme => ({
    embla: {
        overflow: "hidden",
        width: "100%",
    },
    embla__container: {
        display: "flex",
    },
    navButton: {
    },
    embla__next: {
    },
    embla__prev: {
    },
    slideNumber: {
        [theme.breakpoints.down('sm')]: {
            display: "none",
        }
    }
}));

export default function Slider({children, heading, ofText = (slideIndex, totalSlides) => `${slideIndex+1}/${totalSlides}`}) {
    const classes = useStyles();

    const [state, setState] = React.useState({
        currentSlideIndex: 0,
        canScrollPrev: false,
        canScrollNext: false,
    });
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false });

    const updateState = useCallback((eventName) => {
        console.log("Embla event called:", eventName);
        setState({
            currentSlideIndex: emblaApi.selectedScrollSnap(),
            canScrollPrev: emblaApi.canScrollPrev(),
            canScrollNext: emblaApi.canScrollNext(),
        })
    }, [emblaApi, setState]);
    
    useEffect(() => {
        if (!emblaApi) return;
        emblaApi
            // .on("init", updateState)
            .on("select", updateState)
            .on("resize", updateState)
        ;
        // the 'init' event does not seem to be called, or is only called randomly so call the update function manually
        updateState('manualInit');
    }, [emblaApi, updateState])

    const scrollPrev = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollPrev();

    }, [emblaApi])
    
    const scrollNext = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollNext();
    }, [emblaApi])

    return <>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem"}}>
            {heading ? (
                <Typography variant="h5" className="upper">{heading}</Typography>
            ):""}
            <div style={{display: "flex", alignItems: "center"}}>
                <Typography variant="subtitle1" className={[classes.slideNumber, "upper"].join(" ")} style={{marginRight:"1rem"}}>
                    {ofText(state.currentSlideIndex, children.length)}
                </Typography>
                <IconButton
                    className={[classes.navButton, classes.embla__prev].join(" ")}
                    onClick={scrollPrev}
                    disabled={!state.canScrollPrev}
                    size="large">
                    <ChevronLeftIcon />
                </IconButton>
                <IconButton
                    className={[classes.navButton, classes.embla__next].join(" ")}
                    onClick={scrollNext}
                    disabled={!state.canScrollNext}
                    size="large">
                    <ChevronRightIcon />
                </IconButton>
            </div>
        </div>
        <div className={classes.embla} ref={emblaRef}>
            <div className={classes.embla__container}>
                {children}
            </div>
        </div>
    </>;
}